import { Components, Theme } from '@mui/material/styles'

/**
 * ## The two `primary.contrastText` below are CORRECT — do not "fix" them
 *
 * This is the second of the two exceptions in the `primary.contrastText` sweep (the
 * other is `MuiChip.ts`; the remaining seven were wrong and were changed). The test
 * is whether the same rule puts the element on a primary-FILLED surface, and here it
 * does, explicitly and opaquely:
 *
 *   `background: theme.palette.primary.main`   <- an opaque fill of primary
 *   `color:      theme.palette.primary.contrastText`
 *
 * That is the textbook case `contrastText` exists for. On the default black primary
 * it resolves to white-on-black, 21:1; on a light tenant primary MUI flips it to a
 * dark label. Substituting `text.primary` would put the tenant's BODY-TEXT colour on
 * a fill of the tenant's PRIMARY — on the untenanted default, black on black.
 *
 * `&.Mui-selected`'s `border: 1px solid contrastText` is the same story: a white
 * hairline on the black fill the line beneath it re-states. Correct.
 *
 * Contrast this with `MuiTab.ts`, which looked similar and was NOT correct — its
 * selected background is `${primary.main}15`, i.e. primary at ~8% ALPHA, a pale wash
 * rather than a fill, so white text on it computed to about 1.1:1. Alpha suffix vs
 * opaque fill is the whole distinction; check for it before reading a
 * `contrastText`-next-to-a-background as safe.
 *
 * Live call sites exist (`components/pages/certificates/index.tsx` and
 * `productPage/TableHistory.tsx`), so unlike the latent files in this sweep there is
 * something on screen here — but since this file is unchanged, nothing needed
 * re-measuring to justify leaving it alone.
 */
export const MuiPaginationItem: Components<Theme>['MuiPaginationItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.palette.primary.main,
      borderRadius: '4px',
      color: theme.palette.primary.contrastText,
      fontWeight: 700,
      minWidth: '26px',
      fontSize: '12px',
      height: '26px',
      border: `1px solid ${theme.palette.primary.main}`,
      '&.Mui-selected': {
        border: `1px solid ${theme.palette.primary.contrastText}`,
        background: theme.palette.primary.main,
      },
      '&.Mui-disabled': {
        opacity: 1,
        svg: {
          opacity: '0.1',
        },
      },
    }),
  },
}
